import { axiosInstance } from "../axios";

const tenantRoute =  `${process.env.REACT_APP_SCHOOL_REPORTING_BASE}/tenant`;

export const getTenant =  () => {
    return  axiosInstance.get(`${tenantRoute}/getTenant`);

};
export const upsertTenantInfo = (payload) => {
    return axiosInstance.post(`${tenantRoute}/upsertTenantInfo`, payload);
};

export const deleteTenant = (tenantId) => {
    return axiosInstance.delete(`${tenantRoute}/deleteTenant/${tenantId}`);
};